export enum UpdateType {
  DirectDebit = 'directDebit',
  PaymentAndDirectDebit = 'paymentAndDirectDebit',
  Payment = 'payment',
}
